<div mat-dialog-content>
    <mat-card class="prescription-card">
        <mat-card-header>
          <mat-card-title>Prescription électronique</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="rids">
            <div class="rid-container" *ngFor="let barcode of barcodes; let index = index">
              <div class="rid-medication-name">{{ entries[index].value }}</div>
              <div><img class="rid-image" src="{{ barcode }}"></div>
              <div class="rid-number">{{ entries[index].rid }}</div>
            </div>
          </div>
          <button mat-stroked-button class="field-full-width" (click)="print('paper')">Prescription papier</button>
          <button mat-stroked-button class="field-full-width" (click)="print('digital')">Prescription électronique</button>
        </mat-card-content>
        <mat-card-actions>
          <button mat-button [mat-dialog-close]="true">Fermer</button>
        </mat-card-actions>
    </mat-card>
</div>